export const SET_LANGUAGE = "SET_LANGUAGE"
export const SET_LANGUAGES = "SET_LANGUAGES"